import React from 'react';
import genericField from './generic-field';

const Text = genericField('text');

export default Text;
